import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { useTeamAndAllUsers } from "../hook/DataProvider"
import { TimeStringForTimeZone } from "./Setting"
import { toUrlSafeBase64 } from "./utils"
import useAuth from "../hook/useAuth"
import useDeepVinApi from "../hook/useDeepvinApi"

export const Tasks = () => {
  const { auth } = useAuth()
  // const [teamTree, setTeamTree] = useState({})
  const [teams,users] = useTeamAndAllUsers()
  const [flag, setFlag] = useState(false)
  const refresh = () => setFlag(!flag)

  if (auth)
  return (
    <>
    <div class="row">
      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link active internal-tab" id="my-tasks-tab" data-bs-toggle="tab" data-bs-target="#mytasks" type="button" 
          role="tab" aria-controls="mytasks" aria-selected="false">My Tasks{<TaskAlert flag={flag}/>}</button>
        </li>
        {(auth.IsAdmin || auth.IsRoot) && 
        <li class="nav-item" role="presentation">
          <button class="nav-link internal-tab" id="team-tasks-tab" data-bs-toggle="tab" data-bs-target="#teamtasks" type="button" role="tab" aria-controls="teamtasks" aria-selected="false">Team Tasks</button>
        </li>}
        {auth.IsRoot && 
        <li class="nav-item" role="presentation">
          <button class="nav-link internal-tab" id="all-tasks-tab" data-bs-toggle="tab" data-bs-target="#alltasks" type="button" role="tab" aria-controls="alltasks" aria-selected="false">All Tasks</button>
        </li> }

      </ul>
      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade show active" id="mytasks" role="tabpanel" aria-labelledby="my-tasks-tab">
          <TaskGroup category={"self"} taskChanged={refresh} users={users}/>
        </div>
        <div class="tab-pane fade" id="teamtasks" role="tabpanel" aria-labelledby="team-task-tab">
          <TaskGroup category={"team"} taskChanged={refresh} users={users}/>
        </div>
        <div class="tab-pane fade" id="alltasks" role="tabpanel" aria-labelledby="all-tasks-tab">
          <TaskGroup category={"all"} taskChanged={refresh} users={users}/>
        </div>
      </div>
    </div>
    {/* <ReactJson src={users} collapsed={1} /> */}
    </>
  )
}

export const TaskGroup = ({category, taskChanged, users}) => {
  const api = useDeepVinApi()
  //const [teams, users] = useTeamAndUser()
  const [data, setData] = useState([])
  const [flag, setFlag] = useState(false)

  const refresh = () => {
    taskChanged()
    setFlag(!flag)
  }

  useEffect(() => {
    api.get(`/api/task/` + category)
    .then(({data}) => setData(data))
    .catch(error => console.error("API error: ", error))
  }, [flag])

  return (
    <TaskTable refresh={refresh} tasks={data} users={users} isSelf={category === "self"}/>
  )
}

export const TaskTable = ({tasks, users, refresh, isSelf}) => {

  if (tasks)
  return (
    <table class="table table-hover">
      <thead>
        <th>Case Number</th>
        {/*!isSelf && */<th>Owner</th>}
        <th>Description</th>
        <th>Due Date</th>
        <th>Assigned By</th>
        <th>Done</th>
        {/* <th>Last Updated</th> */}
      </thead>
      <tbody>
        {tasks.sort((a,b) => {
            return a.DueDate - b.DueDate
          }).map(task => <TaskTab task={task} refresh={refresh} users={users} isSelf={isSelf}/>)}
      </tbody>
    </table>
  )
}

export const TaskTab = ({task, refresh, users, isSelf}) => {
    //const [data, setData] = useState(task)
    const { auth } = useAuth()
    const api = useDeepVinApi()
    const [done, setDone] = useState(task.Done)
  
    useEffect(() => {
      //setData(task)
      setDone(task.Done)
    }, [task])

    const handleDoneChange = (e) => {
      //setData({...data, ["Done"]: e.target.checked})
      
      api.post(`/api/task/${task.ID}`, {Done: e.target.checked})
      .then(({data}) => {
        setDone(e.target.checked)
        refresh()
      })
      .catch(error => { console.error("Error: ", error) } )
    }
    
    const owner = task /*&& !isSelf*/ && users && users.find((item) => item.ID === task.UserID)
  
    if (task)
    return (
      <>
      <tr>
        <td><Link to={`/case/${toUrlSafeBase64(task.CaseNumber)}`}>{task.CaseNumber}</Link></td>
        {/* <td>{task.CaseNumber}</td> */}
        {/*!isSelf && */owner && <td>{owner.username}</td> }
        <td>{task.Description}</td>
        <td>{ TimeStringForTimeZone(auth, task.DueDate)}</td>
        <td>{task.AssignedBy}
          {/* {sender ? <span>{sender.FirstName} {sender.LastName}</span> : null} */}
        </td>
        <td class="text-center">
            <input class="form-check-input" type="checkbox"
              checked={done} onChange={handleDoneChange}/>
          </td>
      </tr>
      {/* <ReactJson src={{owner, task, users}} /> */}
      </>
    )
}

export const TaskAlert = (flag) => {
  const { auth } = useAuth()
  const api = useDeepVinApi()
  const [tasks, setTasks] = useState([])
  //const [flag, setFlag] = useState(false)

  //const refresh = () => setFlag(!flag)

  useEffect(() => {
    api.get(`/api/task/self/active`)
    .then(({data}) => setTasks(data))
    .catch(error => console.error("API error: ", error))
  }, [flag])

  //refresh()

  if (Object.keys(auth).length > 0 && tasks.length > 0 )
    return (
        <span class="badge rounded-pill bg-danger ms-1">{tasks.length}</span>
    )
}